export const getImage = (backgroundImage) => backgroundImage?.mediaItemUrl ?? ''
